@if (data && data.length > 0) {
  <app-nested-table-form-field
    [editMode]="editMode"
    [fieldConfig]="fieldConfig"
    [formGroup]="formGroup"
    [fields]="fields"
    [data]="data[0].prizeTables[0].prizeTiers"
    (valueChanged)="onValueChanged($event)"
    [canAdd]="canAdd">
  </app-nested-table-form-field>
}
